import React from "react";
import "./PartnershipsSection.css";

// Logos
import logoSJB from "../assets/images/logos/sanJuan.png";
import logoDivina from "../assets/images/logos/c_divina.png";
import logoFe from "../assets/images/logos/feAlegria.png";
import logoJuana from "../assets/images/logos/Alarco.png";

const partnerships = [
  {
    name: "Universidad Privada San Juan Bautista",
    logo: logoSJB,
    link: "https://www.upsjb.edu.pe/",
  },
  {
    name: "CETPRO Divina Providencia",
    logo: logoDivina,
    link: "#",
  },
  {
    name: "Colegio Fe y Alegría",
    logo: logoFe,
    link: "#",
  },
  {
    name: "Colegio Juana Alarco de Dammert",
    logo: logoJuana,
    link: "#",
  },
];

export default function PartnershipsSection() {
  return (
    <section className="partnerships-section">
      <div className="container">
        <h2 className="section-title">
          | Convenios de Transitabilidad y Experiencias Formativas
        </h2>
        <div className="partners-grid">
          {partnerships.map((p, index) => (
            <a
              href={p.link}
              target="_blank"
              rel="noopener noreferrer"
              className="partner-card"
              key={index}
            >
              <div className="partner-logo">
                <img src={p.logo} alt={p.name} />
              </div>
              <p className="partner-name">{p.name}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
